var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Safe_and_secure_transactions",
    "data-name": "Safe and secure transactions",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,0H48V47H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Optimized_for_web_and_mobile",
    "data-name": "Optimized for web and mobile",
    transform: "translate(4 3.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M0,0H40V40H0Z",
    transform: "translate(0 0.667)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "important_devices-24px",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M0,0H40V40H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M38.333,17.017,30,17a1.672,1.672,0,0,0-1.667,1.667v15A1.672,1.672,0,0,0,30,35.333h8.333A1.672,1.672,0,0,0,40,33.667v-15A1.657,1.657,0,0,0,38.333,17.017ZM37.461,32H30.924V20.333h6.536ZM33.333,2h-30A3.322,3.322,0,0,0,0,5.333v20a3.332,3.332,0,0,0,3.333,3.333H16.667V32h-5v3.333H25V32H20V28.667h5V25.333H3.333v-20h30v8.333h3.333V5.333A3.332,3.332,0,0,0,33.333,2Z",
    transform: "translate(0 1.333)",
    fill: "#24397a",
    stroke: "#fff",
    strokeWidth: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDesktop);
export default __webpack_public_path__ + "static/media/mobile-desktop.8990c613ef763011719fe438a446b99a.svg";
export { ForwardRef as ReactComponent };